<template>
  <div class="prev-next demo__flex demo__flex-middle">
    <a-button
      class="demo__button demo__button--gray demo__margin-right--22 demo__margin-right-mobile--10"
      :disabled="!currentViewStudy || !currentViewStudy.previousOrderID"
      @click="$router.push('/loading/study/previous')"
    >
      <i class="fa-light fa-chevron-left m-r"></i>
      <span>
        {{ $t("prev") }}
      </span>
    </a-button>
    <a-button
      class="demo__button demo__button--gray"
      :disabled="!currentViewStudy || !currentViewStudy.nextOrderID"
      @click="$router.push('/loading/study/next')"
    >
      <span>
        {{ $t("next") }}
      </span>
      <i class="fa-light fa-chevron-right m-l"></i>
    </a-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["currentViewStudy", "currentService", "isMobile"]),
  },
};
</script>
